import script from "./DashboardValidation.vue?vue&type=script&lang=js"
export * from "./DashboardValidation.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__